class DummyData {
    constructor() {
        this.data = {
            normal: { 
                DRIVER: { a: 7, v: 6, text: "Der Driver-Stil ist durch hohe Zielorientierung und Durchsetzungsstärke gekennzeichnet. Du übernimmst gerne Führung und treibst Dinge voran. Schnelligkeit und Ergebnisse sind dir wichtig." }, 
                PLANNER: { a: 6, v: 6, text: "Der Planner-Stil ist deutlich ausgeprägt. Stabilität entsteht über Struktur, Verlässlichkeit und einen hohen Qualitätsanspruch. Das ist besonders wertvoll, wenn klare Prozesse und Nachvollziehbarkeit gefragt sind. Für die Balance sind Vereinfachung, Tempo und mutigere Entscheidungen hilfreich." },
                CONNECTOR: { a: 5, v: 7, text: "Der Connector-Stil ist deutlich ausgeprägt. Zusammenarbeit wird vor allem über Beziehung, Einbindung und ein konstruktives Miteinander stabilisiert. Das kann Vertrauen fördern und die Teamarbeit auch in anspruchsvollen Phasen tragen. Als Ausgleich sind klare Grenzen und eine stärkere Ergebnisorientierung hilfreich." },
                INNOVATOR: { a: 6, v: 5, text: "Der Innovator-Stil zeigt sich in Ideenreichtum und der Freude an Neuem. Du denkst gerne über den Status quo hinaus und suchst kreative Lösungen. Routineaufgaben langweilen dich schnell." } 
            },
            stress: { 
                DRIVER: { a: 7, v: 9, text: "Unter Druck neigst du dazu, die Zügel noch straffer in die Hand zu nehmen. Du forderst Ergebnisse ein und kannst dabei ungeduldig wirken." }, 
                PLANNER: { a: 6, v: 8, text: "Im Stress suchst du Sicherheit in Details und Kontrolle. Du prüfst lieber dreimal, bevor ein Fehler passiert, was Prozesse verlangsamen kann." }, 
                CONNECTOR: { a: 5, v: 4, text: "Unter Stress versuchst du, Harmonie zu wahren, und stellst eigene Bedürfnisse zurück. Konflikte belasten dich dann besonders stark." }, 
                INNOVATOR: { a: 6, v: 8, text: "Wenn es eng wird, produzierst du oft noch mehr Ideen, statt eine Sache abzuschließen. Es fällt schwer, den Fokus zu behalten." } 
            }
        };
        this.comp = {
            DRIVER: {
                report: {
                    dimensions: {
                        Absicht_normal: "Hohe Zielorientierung und Durchsetzungskraft...",
                        Verhalten_normal: "Direkte Kommunikation und schnelles Handeln...",
                        Absicht_stress: "Neigt zu Ungeduld und Dominanz...",
                        Verhalten_stress: "Wird autoritär und kontrollierend..."
                    }
                },
                push_pull_context: {
                    normal: { text: "Das Verhalten spiegelt die innere Absicht gut wider." },
                    stress: { text: "Unter Stress verstärkt sich das Verhalten deutlich." }
                }
            },
            PLANNER: {
                report: {
                    dimensions: {
                        Absicht_normal: "Struktur, Sorgfalt und Planung stehen im Vordergrund...",
                        Verhalten_normal: "Präzise Umsetzung und Qualitätsfokus...",
                        Absicht_stress: "Sicherheitsbedürfnis und Detailfokus steigen...",
                        Verhalten_stress: "Kontrolliert stärker und wird regelorientierter..."
                    }
                },
                push_pull_context: {
                    normal: { text: "Absicht und Verhalten sind strukturiert abgestimmt." },
                    stress: { text: "Unter Druck verstärkt sich der Kontrollfokus." }
                }
            },
            CONNECTOR: {
                report: {
                    dimensions: {
                        Absicht_normal: "Beziehungsorientierung und Einbindung prägen dich...",
                        Verhalten_normal: "Empathische Kommunikation und Teamfokus...",
                        Absicht_stress: "Harmoniebedürfnis steigt, Konflikte werden vermieden...",
                        Verhalten_stress: "Stellt eigene Bedürfnisse zurück und vermittelt."
                    }
                },
                push_pull_context: {
                    normal: { text: "Das Verhalten stärkt die Zusammenarbeit." },
                    stress: { text: "Unter Stress wird Harmonie wichtiger als Klarheit." }
                }
            },
            INNOVATOR: {
                report: {
                    dimensions: {
                        Absicht_normal: "Ideenreichtum und Offenheit für Neues...",
                        Verhalten_normal: "Kreative Impulse und Experimentierfreude...",
                        Absicht_stress: "Suchbewegung steigt, Fokus zerstreut sich...",
                        Verhalten_stress: "Springt stärker zwischen Optionen hin und her..."
                    }
                },
                push_pull_context: {
                    normal: { text: "Innovation und Offenheit treiben voran." },
                    stress: { text: "Unter Druck fehlt häufiger die Fokussierung." }
                }
            }
        };
    }

    getData() {
        return this.data;
    }

    getComp() {
        return this.comp;
    }

    getEvaluationData(key) {
        if (!key) return null;
        return this.comp[key] || this.comp[String(key).toUpperCase()] || this.comp[String(key).toLowerCase()] || null;
    }

    getMockJson(values, styles) {
        let maxVal = -1;
        let domStyle = styles[0];
        styles.forEach(s => {
            const val = values?.normal?.verhalten?.[s.key] ?? -1;
            if (val > maxVal) {
                maxVal = val;
                domStyle = s;
            }
        });
        return {
            global_summary: {
                dominant_style: `Als <strong style="color:${domStyle.color}">${domStyle.name}</strong> zeichnest du dich durch eine hohe Ausprägung in diesem Bereich aus. Dein Verhalten ist geprägt durch die typischen Stärken dieses Stils. Du handelst ergebnisorientiert und direkt.`,
                stress_profile: `Unter <strong>Stress</strong> zeigen sich deine verhaltensbedingten Muster deutlicher. Du greifst verstärkt auf deine bevorzugten Strategien zurück, was zu einer Intensivierung deines Profils führt. Achte darauf, in Drucksituationen bewusst gegenzusteuern.`
            }
        };
    }
}

export default DummyData;
